import { call, put, takeEvery, select } from 'redux-saga/effects';
import { SagaIterator } from 'redux-saga';
import API from '../../utils/API';
import {
	fetchTourByIdRequest,
	fetchTourByIdSuccess,
	fetchTourByIdFailure,
	selectTourConfigUrl,
} from './Tours.reducer';
import { Tour } from './Tours.types';

// Default tour configuration URL
const DEFAULT_TOUR_URL = 'http://localhost:3000/';
const DEFAULT_TOUR_DEV_URL = 'https://www.realmofdev.com/exe-v2/';
import { API_BASE, APP_FLOSPACE_DATA_URL } from '../../Common/Common.env';

function* fetchTourByIdSaga({
	payload,
}: {
	payload: { tourId: string; floSpaceId?: string; ext?: string };
}): SagaIterator {
	try {
		console.log('Fetching tour by ID:', payload.tourId);

		// Get the tour URL from Redux store or use default
		let tourUrl: string = DEFAULT_TOUR_URL;
		if (payload.tourId === 'test') {
			tourUrl = DEFAULT_TOUR_URL + payload.tourId + '.json';
		}
		if (payload.tourId.startsWith('dev-')) {
			tourUrl = DEFAULT_TOUR_DEV_URL + payload.tourId + '.json';
		} else if (payload.tourId.startsWith('local-')) {
			tourUrl = DEFAULT_TOUR_URL + payload.tourId + '.json';
		} else if (payload.floSpaceId && payload.tourId !== 'test') {
			tourUrl = `${APP_FLOSPACE_DATA_URL}/c/fs/pt/${payload.tourId}/t_cfg.${
				payload.ext || 'json'
			}`;
		}
		console.log(`Loading tour configuration from: ${tourUrl}`);

		try {
			if (tourUrl.endsWith('.js')) {
				// Use dynamic import to load the tour module
				// @ts-ignore - Dynamic imports with variables need to be ignored for TypeScript
				const tourModule = yield call(() => import(/* webpackIgnore: true */ tourUrl));

				// Get the default export if it exists, otherwise use the module itself
				const tour = tourModule.default || tourModule;

				if (!tour || typeof tour !== 'object' || !tour.id || !tour.tourConfig) {
					throw new Error(
						'Invalid tour format: missing required fields (id, tourConfig)'
					);
				}

				console.log('Tour loaded successfully:', tour);
				yield put(fetchTourByIdSuccess(tour));
			} else if (tourUrl.endsWith('.json')) {
				const tour = yield call(
					new API(undefined, true, undefined, false).get,
					tourUrl + `?timestamp=${Date.now()}`
				);
				console.log('Tour json loaded successfully:', tour);
				yield put(fetchTourByIdSuccess(tour));
			}
		} catch (error: any) {
			console.error('Failed to load tour module:', error);
			throw new Error(`Failed to load tour: ${error.message}`);
		}
	} catch (error: any) {
		console.error('Error in fetchTourByIdSaga:', error);
		const errorMessage = error?.message || 'Failed to fetch tour';
		yield put(fetchTourByIdFailure(errorMessage));
	}
}

export default function* ToursSagas() {
	yield takeEvery(fetchTourByIdRequest.type as any, fetchTourByIdSaga);
}
